import { ReactElement } from 'react'
import Head from 'next/head'

const SEOMain = (): ReactElement => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://medpoint.pro/#organization',
    name: 'Medpoint',
    url: 'https://medpoint.pro',
    logo: 'https://medpoint.pro/static/logo.png',
    description:
      'Профессиональное сообщество врачей для обмена опытом и развития практических навыков',
    foundingDate: '2020',
    offers: {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Образовательные вебинары для врачей',
        description: 'Профессиональные вебинары и конференции для врачей всех специальностей',
      },
    },
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  )
}

export default SEOMain
